module.exports = __webpack_public_path__ + "img/header.d7b8289d.png";